module.exports = __webpack_public_path__ + "static/first-buyer-1bb4a0a5b8df56f307ea17fc76a86eea.jpg";